import { newId, store, type SessionModule, type SessionRecord } from './store/index.ts';

/**
 * A session that records a reward as done without a runner behind it: opening a chest that
 * held a sticker, or watching a story film. It scores nothing (no stars, no points, no attempts)
 * so it never moves the daily totals, but it lands on the same progress key a played session
 * would, which is all the path's lock logic reads.
 */
export function markerSession(
  profileId: string,
  lessonId: string,
  setId: string | null,
  module: SessionModule,
  startedAt: Date = new Date(),
  now: Date = new Date(),
): SessionRecord {
  return {
    id: newId(),
    profileId,
    lessonId,
    setId,
    module,
    character: null,
    score: 0,
    maxScore: 0,
    points: 0,
    stars: 0,
    startedAt: startedAt.toISOString(),
    finishedAt: now.toISOString(),
  };
}

export async function saveMarker(record: SessionRecord): Promise<void> {
  await store.saveSession(record, []);
}

/**
 * Saves a marker in the background, trying again a few times if the round trip fails: nothing on
 * screen waits on it. Saving is idempotent on the session id, so a retry after a timeout that
 * actually landed is harmless. Giving up costs little: the chest opens again (to the same prize)
 * and the film plays again.
 */
export function saveMarkerInBackground(
  record: SessionRecord,
  delaysMs = [1500, 6000, 20000],
): void {
  const attempt = (left: number[]): void => {
    saveMarker(record).catch((e) => {
      const [wait, ...rest] = left;
      if (wait === undefined) {
        console.error('Failed to save reward', e);
        return;
      }
      setTimeout(() => attempt(rest), wait);
    });
  };
  attempt(delaysMs);
}
